export default {"src":"/_next/static/media/login-to-comment.fafe5da8.svg","height":95,"width":95,"blurWidth":0,"blurHeight":0};